import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PatientPrivacyPolicy from "./PatientPrivacyPolicy";
import DoctorPrivacyPolicy from "./DoctorPrivacyPolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/privacy-policy" element={<PatientPrivacyPolicy />} />
          <Route
            path="/doctor-privacy-policy"
            element={<DoctorPrivacyPolicy />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
